import { useState, useEffect } from "react"
import { selectEffectiveUserType } from "../../../../modules/context/contextSelectors"
import { useAppSelector } from "../../../../modules/store/storeHooks"
import { AccountingFilterProps } from "./AccountingFiltersDrawer"

const useActiveFiltersCountAccounting = (filters: AccountingFilterProps) => {
    const [activeCounts, setActiveCounts] = useState({
        merchantActive: 0,
        orderActive: 0,
        debtorActive: 0,
        endUserActive: 0,
        paymentActive: 0,
    })

    const currentUserType = useAppSelector(selectEffectiveUserType)

    useEffect(() => {
        const countActiveFilters = (conditions: any[]) => conditions.filter(Boolean).length

        const orderActiveCount = countActiveFilters([filters.orderId])
        const merchantActiveCount = countActiveFilters([
            filters.merchantIds && filters.merchantIds.length > 0,
            filters.shopIds && filters.shopIds.length > 0,
        ])

        const debtorActiveCount = countActiveFilters([filters.customerId])
        const endUserActiveCount = countActiveFilters([filters.email, filters.employeeId])
        const paymentActiveCount = countActiveFilters([
            filters.creditCardLast4,
            filters.paymentMethods && filters.paymentMethods.length > 0,
        ])

        setActiveCounts({
            merchantActive: merchantActiveCount,
            orderActive: orderActiveCount,
            debtorActive: debtorActiveCount,
            paymentActive: paymentActiveCount,
            endUserActive: endUserActiveCount,
        })
    }, [filters, currentUserType])

    const totalActiveCount = Object.values(activeCounts).reduce((sum, count) => sum + count, 0)

    return {
        activeCount: totalActiveCount,
        ...activeCounts,
    }
}

export default useActiveFiltersCountAccounting
